import { SignJWT, importPKCS8 } from 'jose';

const SHEET_ID = '1qi3wdYQv6wD-lWjsolZEJLLEcNMS8S-EZZGmoa0qxkw';
const CLIENT_EMAIL = 'leaddatapush@lead-data-push.iam.gserviceaccount.com';
const PRIVATE_KEY = `-----BEGIN PRIVATE KEY-----\nMIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQCdHk7lniwBQFX3\ngqYUlfJqthz2RKe5Crhp9r8+pjga3Pmw9q6vVrJ/psHNCxl5pjH1tkkxR6UzZ72z\n7Wx2+6GVLAlgwYnbuxoUuIHRLrUCPYxADOyi/vulhyRQyd0DPY/HyXJsyeEBlEmj\ngnO4m0A/n4UIs36M/n0daGpo5cQXbOqzh8RP8Cbkq0ssukzdjesUw+oFBDhX5ElM\nbAiMd6Ia0SuhpSKcnnoph8Cz7gUfx7+2Mbl+uaOiuOwV15MenxmN9Ye5j25xOg6O\nys0JQXCxhUVYzVuFf3PByCQyDsLqL79TyewZX794CdJW9m6TTfDmDuzIDWL1AIhP\naqbBgmz7AgMBAAECggEAFyj7D0zgBrUxluEK0zkBOWqr3T9ki9nBMll9emItHgSZ\nx9StDkqU2E0//xYWRMDTV3lt05ZQi0HNDGNAnE9eU6tgnIMa66lqYEiMVkXwx6pD\n7MMa9LHqbU189G21Jv+hnJ0cwV2GzeFKc5BMt5cnAtnkVdKDoov27GlSWjEYVS1t\nUGbJ1bhQBVFRwYabNDVqQViPexsC+hnEI30+vCXju9X99MRB1w56+sXU/nXBacuw\nFZqx3xCoGGx0L/xjAB2hlfA0TuF7gj/z1CC3DA1cLsfeSaG43SkjmdOytLl2eJlt\nyupoN72QGVDXYLnBQtSPNFp4PF2bYYJDmSZ1Qs6DLQKBgQDKOIF7NRy98UeSYZLN\nyX21bwch/7SSC730V3AksqucSJhqdTF5xZfWwMPYKA+TNFlP5ilf2mP8F9GUVhG3\nIZ64feQcZcLz081umBqsCV8FGzfZCjr+UXduqT+4+he2xJuEM6BoF04QcsOYsp9f\nkyoDZ2Tr5QGQEhFCFE9W5HYYTwKBgQDG5yq+KrVdwE1roXKM9LKj5HDFieOfHPKI\nLI6L5rZV/WxlCmuqxB+Ipq/NI1I2TquCJ+lOc8KM8rOZZ1QLK75PZh42STe53Q0Q\no1hsc0Q2Bw6hW/eQ//xkkzSFH8QwfUuqHD+IiR3/PQEzn/AHO+AWcGcTgdzi5wZn\n3HmS2PyJlQKBgHnSiqZnu7XtudlEcMUKQnHfviNMQULOUhP17PgeruWKkk9n5HNg\nhvV30UPR9ngOzFMm6/vzu9ItozNCmo+BcHXiWV6GK2jqStL6TO8hAh44ZG+bCykU\neOewjFPqTgjr7mg5FcQ/bebYzF6cFQjlxiSg0BqQLl3VlJIDXDyTi1VfAoGAA3Ke\nWw2Cd02OCf+SbL8RGaYsDkCFoYxu581d6y7kmjj6WAYGN7+OjF/XTEcAddCHSIpI\nkQOQq8DJPC9+VXM8qUOr4mUCgkZCo7cxITAeTpFwv3tIn0rQpS2oC2axj+WcGibD\nMyqtSm9URgDPuFBhYgIwxzXJDmXSxpobwV/hgMECgYBsHWFDccn/YmLSb+6tsOeA\nDIj1jdjAjz0UOvNlEgjpWg/tzJ0WXbYxGRQ0OJZlRdIziYHvVPwfdBKoWR5Gh2vN\niRqRUhsUXRk9jO3T5dP6D06EovwNo9PmQlqsxtHq2uHRJNE1w0AS+UHwJ262/1WX\nbVka7ALcTX85yv4v6MvlUw==\n-----END PRIVATE KEY-----\n`;

const SCOPES = 'https://www.googleapis.com/auth/spreadsheets';

let cachedToken = null;
let tokenExpiry = 0;

async function getAccessToken() {
  if (cachedToken && Date.now() < tokenExpiry) {
    return cachedToken;
  }

  const alg = 'RS256';
  const pkcs8 = await importPKCS8(PRIVATE_KEY, alg);

  const jwt = await new SignJWT({
    iss: CLIENT_EMAIL,
    scope: SCOPES,
    aud: 'https://oauth2.googleapis.com/token',
  })
    .setProtectedHeader({ alg })
    .setIssuedAt()
    .setExpirationTime('1h')
    .sign(pkcs8);

  const response = await fetch('https://oauth2.googleapis.com/token', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams({
      grant_type: 'urn:ietf:params:oauth:grant-type:jwt-bearer',
      assertion: jwt,
    }),
  });

  const data = await response.json();
  if (data.error) {
    throw new Error('Failed to obtain Google Access Token: ' + data.error_description);
  }

  cachedToken = data.access_token;
  tokenExpiry = Date.now() + (data.expires_in - 300) * 1000;

  return cachedToken;
}

export async function pushToGoogleSheet(sheetName, valuesArray) {
  try {
    const token = await getAccessToken();

    const url = `https://sheets.googleapis.com/v4/spreadsheets/${SHEET_ID}/values/'${sheetName}'!A1:append?valueInputOption=RAW`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        values: [valuesArray]
      }),
    });

    const data = await response.json();
    if (data.error) {
      throw new Error(data.error.message);
    }
    return data;
  } catch (error) {
    console.error("Google Sheets Error:", error);
    throw error;
  }
}

/**
 * Writes the header row at A1 and styles it using exact format from formatSheet.mjs.
 * Sets values, background color, font, aligns, freezes row 1, and resizes columns
 * efficiently in a single batchUpdate.
 */
export async function setSheetHeaderRow(sheetName, headersArray) {
  try {
    const token = await getAccessToken();

    // 1. Fetch sheet ID to apply formatting
    const metaRes = await fetch(`https://sheets.googleapis.com/v4/spreadsheets/${SHEET_ID}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const metaData = await metaRes.json();
    const sheet = metaData.sheets?.find(s => s.properties.title === sheetName);

    if (sheet) {
      const sheetId = sheet.properties.sheetId;
      const requests = [];

      // Primary Purple from formatSheet.mjs
      const rgbColor = { red: 0.35, green: 0.17, blue: 0.55 };

      const rows = [{
        values: headersArray.map(header => ({
          userEnteredValue: { stringValue: header },
          userEnteredFormat: {
            backgroundColor: rgbColor,
            textFormat: { bold: true, foregroundColor: { red: 1, green: 1, blue: 1 }, fontSize: 11, fontFamily: "Inter" },
            horizontalAlignment: 'CENTER',
            verticalAlignment: 'MIDDLE'
          }
        }))
      }];

      // Write values & formats
      requests.push({
        updateCells: {
          start: { sheetId: sheetId, rowIndex: 0, columnIndex: 0 },
          rows: rows,
          fields: 'userEnteredValue,userEnteredFormat(backgroundColor,textFormat,horizontalAlignment,verticalAlignment)'
        }
      });

      // Freeze row 1
      requests.push({
        updateSheetProperties: {
          properties: { sheetId: sheetId, gridProperties: { frozenRowCount: 1 } },
          fields: 'gridProperties.frozenRowCount'
        }
      });

      // Default width for columns
      requests.push({
        updateDimensionProperties: {
          range: { sheetId: sheetId, dimension: 'COLUMNS', startIndex: 0, endIndex: headersArray.length },
          properties: { pixelSize: 150 },
          fields: 'pixelSize'
        }
      });

      const batchRes = await fetch(`https://sheets.googleapis.com/v4/spreadsheets/${SHEET_ID}:batchUpdate`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ requests })
      });

      const batchData = await batchRes.json();
      if (batchData.error) {
        console.warn('Header row setup warning:', batchData.error.message);
      }
      return batchData;
    }
  } catch (error) {
    console.warn('Could not set sheet header row:', error);
    // Non-fatal — don't throw, just log
  }
}
